export default function innerHtml(node: Element | undefined) {
  if (node) {
    const data = node.innerHTML
    // Run a regexp to match IE 7 & 8 (and our crawler behavior)
    return data.replace(/\s+/g, " ").trim()
  }
  return undefined
}
